import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LoginModule} from './login/login.module';
import {AngularFireAuthGuard, AuthPipe, customClaims, redirectLoggedInTo} from '@angular/fire/auth-guard';
import {pipe} from 'rxjs';
import {map} from 'rxjs/operators';

const loggedInAndVerified: AuthPipe = map(user => !!user && user.emailVerified);
const passwordUpdated = pipe(customClaims, map(claims => claims.passwordUpdated));
const redirectTrueUnauthorizedTo = (redirect: any[]) => pipe(loggedInAndVerified, map(loggedIn => loggedIn || redirect));
const redirectPasswordNotUpdatedTo = (redirect: any[]) => pipe(passwordUpdated, map(updated => updated || redirect));
const redirectPasswordUpdatedTo = (redirect: any[]) => pipe(passwordUpdated, map(updated => !updated || redirect));
const redirectUnauthorizedToLogin = () => redirectTrueUnauthorizedTo(['auth/login']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);
const redirectToPasswordUpdate = () => redirectPasswordNotUpdatedTo(['auth']);
const redirectToHome = () => redirectPasswordUpdatedTo(['home']);
const nabelAdminOnly = () => pipe(customClaims, map(claims => claims.nabelAdmin ? true : ['home']));
const customerAdminOnly = () => pipe(customClaims, map(claims => claims.customerAdmin ? true : ['home']));
const nabelOrCustomerAdmin = () => pipe(customClaims, map(claims => claims.nabelAdmin || claims.customerAdmin ? true : ['home']));

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'shiyoulot-register',
    loadChildren: () => import('./shiyoulot-register/shiyoulot-register.module').then(m => m.ShiyoulotRegisterModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'chumon',
    loadChildren: () => import('./chumon/chumon.module').then(m => m.ChumonModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'shiyoulot',
    loadChildren: () => import('./shiyoulot/shiyoulot.module').then(m => m.ShiyoulotModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'keisha-meisai',
    loadChildren: () => import('./keisha-meisai/keisha-meisai.module').then(m => m.KeishaMeisaiModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'keisha-info',
    loadChildren: () => import('./keisha-info-ichiran/keisha-info-ichiran.module').then(m => m.KeishaInfoIchiranModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'layout',
    loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'event',
    loadChildren: () => import('./event/event.module').then(m => m.EventModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'genzai-wasuu',
    loadChildren: () => import('./genzai-wasuu/genzai-wasuu.module').then(m => m.GenzaiWasuuModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'shiboukei-report',
    loadChildren: () => import('./shiboukei-report/shiboukei-report.module').then(m => m.ShiboukeiReportModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'alerts',
    loadChildren: () => import('./alert/alert.module').then(m => m.AlertModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'masters',
    loadChildren: () => import('./masters/masters.module').then(m => m.MastersModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectToPasswordUpdate}
  },
  {
    path: 'admin',
    // AdminModuleを遅延読み込みする
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [AngularFireAuthGuard],
    // nabelAdminの権限を持つユーザーのみアクセスを許可
    data: { authGuardPipe: nabelAdminOnly }
  },
  {
    path: 'auth',
    loadChildren: () => LoginModule,
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectToHome},
  },
  {path: '**', redirectTo: 'home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
